import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col paper-texture text-ink'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[70] focus:rounded-full focus:bg-linen focus:px-4 focus:py-2 focus:font-semibold focus:shadow-soft'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1 overflow-x-clip'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
